// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
    emailShippingLabel,
} from './../../store/deviceInfo';

import { logPageAction } from 'src/lib/ApplicationInsights';

interface PropType {
    serialNumber: string;
    serviceRequestNumber: number;
}

export default function EmailLabelLink (props: PropType) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    function onClick (e: any) {
        logPageAction('Email shipping label link clicked');
        
        e.stopPropagation();
        dispatch(emailShippingLabel({
            ...props,
        }));
    }

    return (
        <a href="javascript:;" onClick={onClick}>
            {t('send_email')}
        </a>
    );
}
